import { render, staticRenderFns } from "./photo-macula.vue?vue&type=template&id=82162534&scoped=true&"
import script from "./photo-macula.vue?vue&type=script&lang=js&"
export * from "./photo-macula.vue?vue&type=script&lang=js&"
import style0 from "./photo-macula.vue?vue&type=style&index=0&id=82162534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82162534",
  null
  
)

export default component.exports